export interface AdvertSearchCount {
  name: string;
  entityId: number;
  count: number;
  groupName: string;
  checked?: boolean;
}
